/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ExtendedPaginationBox } from "@nordcloud/gnui";
import { PaginationState } from "./Pagination";

type Props = {
  count: number;
  small?: boolean;
  paginationParams: PaginationState;
  onPaginationChange: (paginationParams: PaginationState) => void;
};

export function StandalonePagination({
  count,
  small,
  paginationParams,
  onPaginationChange,
}: Props) {
  return (
    <ExtendedPaginationBox
      small={small}
      count={count}
      from={startFrom(paginationParams.page, paginationParams.limit)}
      size={paginationParams.limit}
      setPage={(newPage) =>
        onPaginationChange({
          ...paginationParams,
          page: startByPage(newPage, paginationParams.limit),
        })
      }
      setSize={(newLimit) =>
        onPaginationChange({
          ...paginationParams,
          page: 0,
          limit: startByLimit(newLimit),
        })
      }
    />
  );
}

const startByPage = (currentPage: number, pageLimit: number) =>
  currentPage / pageLimit;

const startByLimit = (pageLimit: number) => pageLimit;

const startFrom = (currentPage: number, pageLimit: number) =>
  currentPage * pageLimit;
